import { formatData, getGaClientId } from '@common/Tracking';
import { getItemsParameters } from '@common/Tracking/itemsParameters';
import { pushEventToDataLayer } from '@helpers/dataLayer';
import { getUrlParameter } from '@helpers/urlHelper';
import { getVisitorDataCookieAsObject } from '@helpers/visitor';

const GaCartChange = (eventType, product) => {
    const {
        id,
        quantity,
        name,
        brand,
        variant,
        category,
        has_sustainability_icon: hasSustainabilityIcon,
        hasVideo360
    } = product;
    let quantityValue = 1;

    if (typeof quantity !== 'undefined') {
        quantityValue = quantity;
    }

    const { item_list_name: itemListName } = getItemsParameters() ?? {};

    const eventData = {
        ...formatData(getVisitorDataCookieAsObject()),
        ...App.Config.GaTrackingData,
        client_id: getGaClientId(),
        ecommerce: {
            currencyCode: App.Config.currency,
            [eventType]: {
                actionField: {
                    list: itemListName
                },
                products: [{
                    id,
                    quantity: quantityValue,
                    name,
                    brand,
                    variant,
                    category,
                    has_sustainability_icon: hasSustainabilityIcon,
                    hasVideo360
                }]
            }
        }
    };

    const action = eventType === 'add' ? `${eventType} to cart` : `${eventType} from cart`;

    const eventInfo = {
        category: 'cart',
        action,
        non_interaction: 1
    };

    if (eventType === 'add') {
        eventInfo.label = getUrlParameter('group');
    }

    const eventName = `eec.${eventType}`;

    pushEventToDataLayer(eventName, eventInfo, eventData);
};

const findAffectedProduct = (eventType, products, id) => {
    if (Array.isArray(products) && id) {
        const removedProduct = products.find(item => item.id === id);
        GaCartChange(eventType, removedProduct);
    } else {
        GaCartChange(eventType, products);
    }
};

export const trackGaCartChange = () => {
    App.Config.GaCartChange = findAffectedProduct;
};
